import React, { Component } from 'react';
import { connect } from "react-redux";
import './camera_with_framing.css';
import { Button, Col, Glyphicon, Grid, Row } from 'react-bootstrap';
import { setImage, setShowError, setErrorType, setData, setMessageModalVisibility } from '../../redux/actionCreators';
import Webcam from "react-webcam";
import FooterContainer from '../../components/footer/FooterContainer';
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';
import MainButton from '../../components/buttons/main_button/MainButton';
import imageProcess from '../../library/ImageProcess';
import AutoCaptureHelper from './autocaptureHelper';
import FramingFront from './icons/framing-front'
import FramingBack from './icons/framing-back'
import FramingBackNew from './icons/framing-back-new';
import { validateImageQuality } from '@autofact-lib/autofact-lib-check-image-quality';
import config from '../../config/config';
import MessageModal from '../../components/message_modal/MessageModal';

const NEW_CARD_TYPE = 'CHL3';
class CameraWithFraming extends Component {
  constructor(props) {
    super(props);
    this.state = {
      facingMode: props.stepInfo.defaultCamera || 'environment',
      capturedImage: null,
      devices: [],
      selectedDeviceId: null,
      isAppleDevice: /iPhone|iPad|iPod/i.test(navigator.userAgent),
      isChrome: /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.userAgent),
      aspectRatio: this.calculateAspectRatio(),
      feedbackMessage: 'Centra tu carnet en el área marcada para capturar.',
      iconColor: 'white',
      autoCaptureActive: props.stepInfo.isAutoCapture || false,
      deviceOrientation: window.screen.orientation?.angle || 0,
      withLimitedRetry: props.stepInfo.withLimitedRetry || false,
    };
    this.validateImageQuality = props.stepInfo.validateImageQuality || false;
    this.webcamRef = React.createRef();
    this.captureImage = this.captureImage.bind(this);
    this.retry = this.retry.bind(this);
    this.setImageInternal = this.setImageInternal.bind(this);
    this.toggleCamera = this.toggleCamera.bind(this);
    this.closeMessageModal = this.closeMessageModal.bind(this);
    this.GetRetryModalMessage = this.GetRetryModalMessage.bind(this);
    this.autoCaptureHelper = null;
    this.images = [];
  }

  async componentDidMount() {
    window.scrollTo(0, document.body.scrollHeight);
    await this.handleInitCamera()
  }

  async handleInitCamera(){
    const STRATEGIES_CAMERA_SELECTION = {
      default: async () => {
        await this.loadOpenCV();
        await this.getMediaDevices();
        if(this.state.autoCaptureActive){
          await this.autoCaptureHelper.startDetectionLoop();
          this.setAutoCaptureTimeout();
        }
      },
      bestCamera: async () => {
        await this.loadOpenCV();
        await this.checkMediaDevices();
      }
    }
    const strategy =  STRATEGIES_CAMERA_SELECTION[config.strategyCameraSelection] ? config.strategyCameraSelection : 'default';
    await STRATEGIES_CAMERA_SELECTION[strategy]();
  }

  loadReferenceImages(){
    const referenceImages = {
      'front': [
        require('../../resources/images/new-ci-front-ejemplo.jpg').default,
        require('../../resources/images/ci-ejemplo.jpg').default,
        require('../../resources/images/ci-antigua-ejemplo-front.png').default,
      ],
      'back': [
        require('../../resources/images/new-ci-back-ejemplo-2.jpeg').default,
        require('../../resources/images/ci-back-ejemplo.jpg').default,
        require('../../resources/images/ci-antigua-ejemplo-back.png').default,
      ]
    }

    this.autoCaptureHelper.loadReferenceImages(referenceImages[this.props.stepInfo.referenceImagesCi]);
  }

  updateFeedback(message, color) {
    this.setState({
      feedbackMessage: message,
      iconColor: color,
    });
  }

  async getMediaDevices() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: this.state.facingMode } });
      this.webcamRef.current.srcObject = stream;
    } catch (error) {
      console.error("Error al obtener dispositivos de medios o permisos:", error);
    }
  }

  async checkMediaDevices() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: this.state.facingMode } });
      stream.getTracks().forEach(track => track.stop());
          
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(device => device.kind === 'videoinput');
      // Excluir cámaras gran angulares basándonos en etiquetas
      const backCameras = videoDevices.filter(device => {
        const label = device.label.toLowerCase();
        const isBackCamera = 
            label.includes('back') || 
            label.includes('trasera') || 
            label.includes('rear') || 
            label.includes('posterior');
        const isExcluded = 
            label.includes('angular') || 
            label.includes('telephoto') || 
            label.includes('doble') ||
            label.includes('triple') ||
            label.includes('teleobjetivo') ||
            label.includes('dual');
        return isBackCamera && !isExcluded;
      }
      ).reverse();

      if(backCameras.length > 1){
        const bestCamera = await this.autoCaptureHelper.selectBestCamera(backCameras);
        if (bestCamera) {
          this.setState({ selectedDeviceId: bestCamera });
          const stream = await navigator.mediaDevices.getUserMedia({ video: { deviceId: bestCamera } });
          this.webcamRef.current.srcObject = stream;
        }
      }else{
        this.setState({ selectedDeviceId: backCameras[0].deviceId });
        const stream = await navigator.mediaDevices.getUserMedia({ video: { deviceId: backCameras[0].deviceId } });
        this.webcamRef.current.srcObject = stream;
      }
    } catch (error) {
      console.log(`Error al obtener dispositivos de medios o permisos: ${error}`);
      await this.getMediaDevices()
    }finally{
      if(this.state.autoCaptureActive){
        await this.autoCaptureHelper.startDetectionLoop();
        this.setAutoCaptureTimeout();
      }
    }

  }

  async loadOpenCV(force = false){
    this.autoCaptureHelper = null;
    this.autoCaptureHelper = new AutoCaptureHelper(
      this.webcamRef,
      this.updateFeedback.bind(this),
      this.captureImage.bind(this),
      this.props.stepInfo.referenceImagesCi,
    );
    await this.autoCaptureHelper.loadOpenCV();
    if (this.state.autoCaptureActive || force) {
      this.loadReferenceImages();
    }
  }

  calculateAspectRatio() {
    const width = window.screen.availWidth;
    const height = window.screen.availHeight;
    if(width > height) {
      return width / height;
    }
    return height / width;
  }

  captureImage(image, data) {
    console.trace()
    if (!this.state.autoCaptureActive &&  this.webcamRef.current.getScreenshot()) {
      const imageSrc = this.webcamRef.current.getScreenshot();
      const img = new Image();
      img.src = imageSrc;
      let isValidQuality = true;
      img.onload = async () => {
        const qualityResult = await validateImageQuality(img, {customThresholds: config.customThresholds}, this.props.stepInfo.referenceImagesCi);
        console.log(qualityResult)
        let finalImageSrc = imageSrc;
        if (this.validateImageQuality) {
          if (!qualityResult.brightness) {
            this.updateFeedback('Tienes poca luz, mejora la iluminación.', 'red');
            isValidQuality = false;
          }
          if (!qualityResult.contrast) {
            this.updateFeedback('Tienes mucha luz, disminuye la iluminación.', 'red');
            isValidQuality = false;
          }
          if (!qualityResult.sharpness) {
            this.updateFeedback('La imagen está desenfocada, mueve el teléfono hasta mejorarla', 'yellow');
            isValidQuality = false;
          }
          if (!qualityResult.readableQrCode && this.props.stepInfo.referenceImagesCi == 'back') {
            this.updateFeedback('La imagen está desenfocada, mueve el teléfono hasta mejorarla', 'yellow');
            isValidQuality = false;
          }

          this.images.push({
            image: imageSrc,
            quality: qualityResult
          })
          
          if(!isValidQuality && this.state.withLimitedRetry && this.images.length < config.limitAttemptsQualityCheck){
            this.props.setMessageModalVisibility(true)
            return;
          }

          finalImageSrc = this.images.reduce((max, current) => {
            return current.quality.scores.overallScore > max.quality.scores.overallScore ? current : max;
          }, this.images[0]);

          finalImageSrc = finalImageSrc.image;
        }
        this.setState({ capturedImage: finalImageSrc });
        this.setImageInternal(finalImageSrc);
        const data = {
          isAppleDevice: this.state.isAppleDevice,
          validateImageQuality: this.validateImageQuality,
          isAutoCaptureOriginal: this.props.stepInfo.isAutoCapture,
          isAutoCapture: this.state.autoCaptureActive,
          withLimitedRetry: this.state.withLimitedRetry,
          quantityOfImages: this.images.length,
          ...qualityResult
        }
        this.props.setData(data)
      };
      img.onerror = () => {
        console.error("Error al cargar la imagen para validación");
      };
      return;
    }

    if(image){
      this.setState ({
        capturedImage: image,
      });
      this.setImageInternal(image);
      const new_data = {
        isAppleDevice: this.state.isAppleDevice,
        validateImageQuality: this.validateImageQuality,
        isAutoCaptureOriginal: this.props.stepInfo.isAutoCapture,
        isAutoCapture: this.state.autoCaptureActive,
        withLimitedRetry: this.state.withLimitedRetry,
        quantityOfImages: this.images.length,
        ...data
      }
      this.props.setData(new_data);
      this.autoCaptureHelper.stopDetection();
      clearTimeout(this.autoCaptureTimeout);
      this.setState({ autoCaptureActive: this.props.stepInfo.isAutoCapture || false  });
    }
  }

  setFrontalCamera = () => {
    this.setState({ facingMode: "user" });
  };

  setBackCamera = () => {
    this.setState({ facingMode: "environment" });
  };

  toggleCamera() {
    this.setState(prevState => ({
      facingMode: prevState.facingMode === 'user' ? 'environment' : 'user'
    }));
  }

  rotateImage = async () => {
    const image = await imageProcess.rotateImage(this.state.capturedImage);
    this.setState({ capturedImage: image });
    this.setImageInternal(image);
  };

  setImageInternal = (image) => {
    try {
      this.props.setImage(image);
    } catch (error) {
      this.props.setErrorType('defaultImage');
    }
  }

  async retry() {
    this.images = [];
    this.setState({ capturedImage: null, autoCaptureActive: this.props.stepInfo.isAutoCapture || false }, async () => {
      await this.handleInitCamera()
    });
  }

  getFraming(icon){
    icon = icon ? icon.split('.')[0] : 'ci-front'
    const framings = {
      'ci-back': <FramingBack className="camera-icon" iconColor={this.state.iconColor}/>,
      'ci-back-new': <FramingBackNew className="camera-icon" iconColor={this.state.iconColor}/>,
      'ci-front': <FramingFront className="camera-icon" iconColor={this.state.iconColor}/>,
    }
    if(icon === 'ci-back' && this.props.stepInfo.cardType === NEW_CARD_TYPE){
      icon = 'ci-back-new';
    }
    return framings[icon]
  }

  setAutoCaptureTimeout() {
    clearTimeout(this.autoCaptureTimeout);
    this.autoCaptureTimeout = setTimeout(() => {
      this.autoCaptureHelper.stopDetection();
      this.setState({ autoCaptureActive: false });
      this.updateFeedback('Autocaptura desactivada, favor usa el botón para capturar la imagen.', 'white');
    }, config.timeout_autocapture_seconds);
  } 

  closeMessageModal(){
    this.props.setMessageModalVisibility(false);
  }

  GetRetryModalMessage(){
    return {
      title:"La imagen capturada quedó borrosa. Intenta nuevamente",
      principalMessage:[
        "Mantén la cámara fija o mejora la iluminación. Recuerda que tienes ",
        <strong key="bold">solo 3 intentos en total.</strong>,
      ]
    }
  }
  render() {
    const videoConstraints = {
      facingMode: {ideal: this.state.facingMode},
      deviceId: this.state.selectedDeviceId || undefined,
      aspectRatio: this.state.aspectRatio,
      autoGainControl: true,
      audio: false,
      width: 640,
      height: 480
    };
    const ToggleCameraIcon = require('../../resources/images/turncamera.svg').default;
    return (
      <>
        {this.state.capturedImage ? (
          <div className={'preview'}>
            
                <PageWithFooter
                    footer={(
                        <FooterContainer>
                  <Col xs={6}>
                    <div className={'camera-button'}>
                      <MainButton
                        onClick={this.retry}
                        text={'Repetir'}
                        outline={true}
                      >
                      </MainButton>
                    </div>
                  </Col>
                  <Col xs={6}>
                    <MainButton
                      onClick={this.props.nextStep}
                      className={'next-button'}
                    >
                      Continuar
                    </MainButton>
                  </Col>
                </FooterContainer>
                    )}
                >
                <Grid>
              <div className="content">
                <Row>
                  <div className={'rotate-button'}>
                    <Button onClick={this.rotateImage}>
                      <Glyphicon glyph="repeat" />
                    </Button>
                  </div>
                  <Col xs={12} className={'content-image'}>
                    <p className={'content-description'}>Revisa que la imagen sea legible; si no lo es, inténtalo de nuevo.</p>
                    <img src={this.state.capturedImage} />
                  </Col>
                </Row>
              </div>
            
                </Grid>
                </PageWithFooter>
          </div>
        ) : (
          <div className={`camera-with-framing${this.state.isChrome ? '-android' : ''}`}>
            <Webcam
              audio={false}
              ref={this.webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              className={''}
              style={{ width: '100%', height: '100%' }}
              playsInline
            />
            <div className='camera-framing'>
              {this.getFraming(this.props.stepInfo.icon)}
            </div>
              <div className="feedback-message">
                {this.state.feedbackMessage}
              </div>
            
            {
              this.props.stepInfo.showSelectCamera &&
              <div className="config-button">
                <Button onClick={this.setFrontalCamera}>Frontal</Button>
                <Button onClick={this.setBackCamera}>Trasera</Button>
              </div>
            }
            <div className="button-container-">
              { (!this.state.autoCaptureActive) && <Button className={'capture-button'} onClick={this.captureImage}></Button>}
              <div className={'toggle-camera-button'} onClick={this.toggleCamera}><img src={ToggleCameraIcon} /></div>
            </div>
            <MessageModal
              {...this.GetRetryModalMessage()}
              type={'warningRed'}
              alingButtons={'right'}
              buttons={
                <MainButton
                  onClick={this.closeMessageModal}
                  text={"Reintentar la captura"}
                  class={"blue-button button-large"}
                />
              }
            />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    component: state.component,
    image: state.image,
    capturedImage: state.capturedImage,
    showError: state.showError,
    setErrorType: state.setErrorType,
    stepInfo: state.stepInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setImage(image) {
      dispatch(setImage(image));
    },
    setShowError(showError) {
      dispatch(setShowError(showError));
    },
    setErrorType(errorType) {
      dispatch(setErrorType(errorType));
    },
    setData: (data) => {
      dispatch(setData(data));
    },
    setMessageModalVisibility(messageModalVisibility) {
      dispatch(setMessageModalVisibility(messageModalVisibility));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CameraWithFraming);
